import { Component, EventEmitter, HostBinding, Output } from '@angular/core';

import { CookiesModalComponent } from '@app/presentation/components/modals/cookies-modal/cookies-modal.component';
import { ModalManager, NavigationEvent, NavigationEvents, NavigationService } from '@app/services';
import { ActionCookies } from '@app/shared/models/cookies/cookies.config';
import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';

import { MButtonComponent } from '@mercadona/components-musi/button';
import { MTranslatePipe } from '@mercadona/core/translate';

import { PAGES } from '@/enums/pages.enum';

@Component({
  selector: 'app-lightbox-cookies',
  imports: [MTranslatePipe, MButtonComponent],
  templateUrl: './lightbox-cookies.component.html',
  styleUrls: ['./lightbox-cookies.component.scss']
})
export class LightboxCookiesComponent {
  @HostBinding('hidden') isConfiguring = false;
  @Output() action: EventEmitter<MSafeAny> = new EventEmitter();

  constructor(
    private navigationservice: NavigationService,
    private modalManager: ModalManager
  ) {}

  acceptCookies() {
    this.action.emit({ action: ActionCookies.ACCEPT });
  }

  rejectCookies() {
    this.action.emit({ action: ActionCookies.REJECT });
  }

  goToCookiesPage() {
    const navEvent = new NavigationEvent(NavigationEvents.Push, { path: PAGES.COOKIES });
    this.navigationservice.navigate(navEvent);
  }

  async configCookies() {
    this.isConfiguring = true;
    const cookiesModal = this.modalManager.openModal(CookiesModalComponent, {
      data: { hasAcceptedCookies: false },
      panelClass: 'cookies-modal'
    });

    cookiesModal.afterClosed().subscribe((event) => {
      this.isConfiguring = false;
      if (event) {
        this.action.emit({ action: event.action, cookies: event.cookies });
      }
    });
  }
}
